"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVehicleReservationsFilterDto = exports.GetVehicleReservationsDTO = exports.VehicleReservationsOptions = exports.UpdateVehicleReservationDto = exports.VehicleReservationResponseDto = exports.VehicleReservationDto = exports.CreateVehicleReservationDto = void 0;
const class_validator_1 = require("class-validator");
const finance_type_1 = require("../enums/finance-type");
const reservation_type_1 = require("../enums/reservation-type");
const class_transformer_1 = require("class-transformer");
const global_1 = require("../../../../global");
const lead_dto_1 = require("../../../lead/data/dto/lead_dto");
const faq_1 = require("../../../faq");
class CreateVehicleReservationDto {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(CreateVehicleReservationDto, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.ValidateIf)((o) => !o.newLead),
    __metadata("design:type", String)
], CreateVehicleReservationDto.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => lead_dto_1.LeadCreateDTO),
    (0, class_validator_1.ValidateIf)((o) => !o.leadId),
    __metadata("design:type", lead_dto_1.LeadCreateDTO)
], CreateVehicleReservationDto.prototype, "newLead", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CreateVehicleReservationDto.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(finance_type_1.FinanceType),
    __metadata("design:type", String)
], CreateVehicleReservationDto.prototype, "financeType", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], CreateVehicleReservationDto.prototype, "depositAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateVehicleReservationDto.prototype, "depositPaymentMethod", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], CreateVehicleReservationDto.prototype, "totalAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateVehicleReservationDto.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateVehicleReservationDto.prototype, "assignedSalesRepId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateVehicleReservationDto.prototype, "bankName", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], CreateVehicleReservationDto.prototype, "loanAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], CreateVehicleReservationDto.prototype, "loanTenureMonths", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], CreateVehicleReservationDto.prototype, "interestRate", void 0);
exports.CreateVehicleReservationDto = CreateVehicleReservationDto;
class VehicleReservationDto {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(CreateVehicleReservationDto, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], VehicleReservationDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], VehicleReservationDto.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(finance_type_1.FinanceType),
    __metadata("design:type", String)
], VehicleReservationDto.prototype, "financeType", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleReservationDto.prototype, "depositAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleReservationDto.prototype, "depositPaymentMethod", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleReservationDto.prototype, "totalAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleReservationDto.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleReservationDto.prototype, "assignedSalesRepId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleReservationDto.prototype, "bankName", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleReservationDto.prototype, "loanAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleReservationDto.prototype, "loanTenureMonths", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleReservationDto.prototype, "interestRate", void 0);
exports.VehicleReservationDto = VehicleReservationDto;
class VehicleReservationResponseDto {
}
exports.VehicleReservationResponseDto = VehicleReservationResponseDto;
class UpdateVehicleReservationDto {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(UpdateVehicleReservationDto, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsEnum)(reservation_type_1.ReservationStatus),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVehicleReservationDto.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], UpdateVehicleReservationDto.prototype, "depositAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVehicleReservationDto.prototype, "depositPaymentMethod", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], UpdateVehicleReservationDto.prototype, "isDepositPaid", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], UpdateVehicleReservationDto.prototype, "totalAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVehicleReservationDto.prototype, "bankName", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], UpdateVehicleReservationDto.prototype, "loanAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], UpdateVehicleReservationDto.prototype, "loanTenureMonths", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVehicleReservationDto.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVehicleReservationDto.prototype, "cancellationReason", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVehicleReservationDto.prototype, "assignedSalesRepId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVehicleReservationDto.prototype, "financeRejectionReason", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], UpdateVehicleReservationDto.prototype, "financeApprovedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], UpdateVehicleReservationDto.prototype, "financeRejectedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], UpdateVehicleReservationDto.prototype, "cancelledAt", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], UpdateVehicleReservationDto.prototype, "isActive", void 0);
exports.UpdateVehicleReservationDto = UpdateVehicleReservationDto;
class VehicleReservationsOptions extends global_1.PaginationOptions {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(GetVehicleReservationsFilterDto, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => faq_1.SortDTO),
    __metadata("design:type", Object)
], VehicleReservationsOptions.prototype, "sort", void 0);
exports.VehicleReservationsOptions = VehicleReservationsOptions;
class GetVehicleReservationsDTO {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(GetVehicleReservationsDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
exports.GetVehicleReservationsDTO = GetVehicleReservationsDTO;
class GetVehicleReservationsFilterDto {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(GetVehicleReservationsFilterDto, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GetVehicleReservationsFilterDto.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(reservation_type_1.ReservationStatus),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GetVehicleReservationsFilterDto.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(reservation_type_1.ReservationStatus),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GetVehicleReservationsFilterDto.prototype, "exceptStatus", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(finance_type_1.FinanceType),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], GetVehicleReservationsFilterDto.prototype, "financeTypes", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(finance_type_1.FinanceType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GetVehicleReservationsFilterDto.prototype, "financeType", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GetVehicleReservationsFilterDto.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", global_1.DateFilter)
], GetVehicleReservationsFilterDto.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GetVehicleReservationsFilterDto.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], GetVehicleReservationsFilterDto.prototype, "isActive", void 0);
exports.GetVehicleReservationsFilterDto = GetVehicleReservationsFilterDto;
